module.exports = __webpack_public_path__ + "static/media/thumb_HZOQ1951_1024.b98d4f3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/thumb_HZOQ1951_1024.jpg
// module id = 135
// module chunks = 0